import { css } from 'styled-components';
import { ActionsMenuWithThemeProps } from './actions-menu.model';

export const ActionsMenuStyle = ({ theme }: ActionsMenuWithThemeProps) => {
  return css`
    > .drop-shadow {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.05);
      z-index: 10;
    }

    > .actions-menu-container {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: relative;

      > .action-icon-container {
        cursor: pointer;
        width: 32px;
        height: 27px;
        border-radius: 50px;
        &.open-state {
          background: ${theme.colors.grayWhite};
        }
      }

      > .actions-menu {
        position: absolute;
        background-color: ${theme.colors.white};
        min-width: 200px;
        box-shadow: 0 8px 28px -6px rgba(24, 39, 75, 0.12), 0px 18px 88px -4px rgba(24, 39, 75, 0.14);
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        padding: 8px;
        gap: 8px;
        top: 33px;
        left: -175px;
        z-index: 11;

        > .action-menu-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 8px 12px;
          gap: 8px;
          border-radius: 4px;
          cursor: pointer;

          &:hover {
            background-color: ${theme.colors.grayWhite};
          }

          > .menu-item-text {
            font-weight: 700;
            font-size: 12px;
            line-height: 18px;
            color: ${theme.colors.primary};
          }
          > .menu-item-icon {
            width: 17px;
            height: 17px;
          }
        }
      }
    }
  `;
};
